import React, { useEffect, useState } from "react";
import { createUrl, get } from "../../../network/AxiosInterceptor";
import { LeadsView } from "./LeadsView";

export const LeadsContainer = () => {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    get(createUrl(`/api/leads/`), {})
      .then((response) => {
        setLeads(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div>
      <h1>Leads Page</h1>
      <LeadsView leads={leads} />
    </div>
  );
};
